import { ChevronLeftSharp, ChevronRightSharp } from '@mui/icons-material';
import { Grid, Container } from '@mui/material';
import MKBox from 'components/MKBox';
import MKPagination from 'components/MKPagination';
import MKTypography from 'components/MKTypography';
import data from 'csdd_data/industryUpdates';
import TransparentBlogCard from 'examples/Cards/BlogCards/TransparentBlogCard';

const IndustryUpdatesContent = () => {
  return (
    <MKBox
      id='start'
      sx={{
        py: 10,
      }}
    >
      <Container>
        {data.length === 0 ? (
          <MKTypography textAlign='center' color='warning'>
            Industry updates are not available at the moment.
          </MKTypography>
        ) : (
          <>
            <Grid container spacing={3}>
              {data.map((update) => {
                return (
                  <Grid item xs={12} sm={6} lg={4} key={update.href}>
                    <TransparentBlogCard
                      image={update.headerImage}
                      title={update.title}
                      action={{
                        type: 'external',
                        route: `${update.href}`,
                        color: 'error',
                        label: 'visit link',
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Container sx={{ mt: 10 }}>
              <MKPagination placement='center'>
                <MKPagination item>
                  <ChevronLeftSharp color='warning' />
                </MKPagination>
                <MKPagination item active>
                  1
                </MKPagination>
                <MKPagination item>2</MKPagination>
                <MKPagination item>3</MKPagination>
                <MKPagination item>
                  <ChevronRightSharp color='warning' />
                </MKPagination>
              </MKPagination>
            </Container>
          </>
        )}
      </Container>
    </MKBox>
  );
};
export default IndustryUpdatesContent;
